import HiddenMixin from './HiddenMixin';
import CollapsedMixin from './CollapsedMixin';
import mixin from '../../privates/utils/mixin';

/**
 * @mixin HiddenCollapsedMixin
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @description
 *  The `HiddenCollapsedMixin` [mixin](https://support.wix.com/en/article/velo-about-mixins) provides properties and functions that elements can inherit and use.
 *  
 *  > **Note:** Mixins are not elements. You cannot add mixins to a page in the Editor like other `$w` elements, and mixins are not meant to be used directly 
 *  in your code. 
 * 
 *  
 * @mixes $w.HiddenMixin
 * @mixes $w.CollapsedMixin
 * @memberof $w
 */
class HiddenCollapsedMixin {
}

mixin(HiddenCollapsedMixin.prototype, HiddenMixin.prototype);
mixin(HiddenCollapsedMixin.prototype, CollapsedMixin.prototype);
export default HiddenCollapsedMixin;
